import { createContext, ReactNode, useContext } from "react";

import { useFilterUtilTransportLocation } from "./filter-util-transport-location.hook";

const FilterUtilTransportLocationContext = createContext(
  {} as ReturnType<typeof useFilterUtilTransportLocation>
);
export function useFilterUtilTransportLocationContext() {
  return useContext(FilterUtilTransportLocationContext);
}

interface FilterUtilTransportLocationProviderProps {
  children: ReactNode;
}
export function FilterUtilTransportLocationProvider({
  children,
}: FilterUtilTransportLocationProviderProps) {
  return (
    <FilterUtilTransportLocationContext.Provider value={useFilterUtilTransportLocation()}>
      {children}
    </FilterUtilTransportLocationContext.Provider>
  );
}